import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthorizedEntities } from '../../actions/lp';
import {
  getAuthorizedEntitiesSelector,
  getAuthorizedLpSelectedSelector,
} from '../../actions/lp/selectors';
import { ENTITY_FILTER_ENUMS } from '../../constants/authorization';

export function useAuthorizedEntities() {
  const dispatch = useDispatch();
  const lpSelected = useSelector(getAuthorizedLpSelectedSelector);

  const authorizedEntities = useSelector(getAuthorizedEntitiesSelector);

  useEffect(() => {
    if (isEmpty(lpSelected) || isEmpty(lpSelected?.lpId)) return;

    dispatch(
      getAuthorizedEntities.request({
        entityFilter: ENTITY_FILTER_ENUMS.NO_FILTER,
      })
    ); // To Fetch All authorized Entities
  }, [dispatch, lpSelected]);

  return authorizedEntities;
}
